import request from '@/utils/request'

// 查询【地区】列表
export function listArea(query) {
  return request({
    url: '/system/area/list',
    method: 'get',
    params: query
  })
}

// 查询【地区】详细
export function getArea(areaId) {
  return request({
    url: '/system/area/' + areaId,
    method: 'get'
  })
}

// 新增【地区】
export function addArea(data) {
  return request({
    url: '/system/area',
    method: 'post',
    data: data
  })
}

// 修改【地区】
export function updateArea(data) {
  return request({
    url: '/system/area',
    method: 'put',
    data: data
  })
}

// 删除【地区】
export function delArea(areaId) {
  return request({
    url: '/system/area/' + areaId,
    method: 'delete'
  })
}

// 导出【地区】
export function exportArea(query) {
  return request({
    url: '/system/area/export',
    method: 'get',
    params: query
  })
}

//获取所有地区列表
export function treeselect() {
  return request({
    url: '/system/area/treeselect',
    method: 'get'
  })
}

//获取省市列表
export function getProvinceCityList() {
  return request({
    url: '/system/area/selectProvinceCityList',
    method: 'get'
  })
}

